import React from "react";
import conditionIcon from "../../../../icons/condition.png";
import paginationIcon from "../../../../icons/pagination.png";
import iterationIcon from "../../../../icons/iteration.svg";
import Tooltip from "@atlaskit/tooltip";

export const getActionIcon = (actionType) => {
  if (actionType.includes("CONDITION")) {
    return (
      <>
        <Tooltip position="top" content="This action has data condition enabled">
          <img className="icon24 icon-action-behaviour" src={conditionIcon} alt="Condition Action" />
        </Tooltip>
      </>
    );
  }
  if (actionType.includes("ITERATION")) {
    return (
      <>
        <Tooltip position="top" content="This action iterates over input data">
          <img className="icon24 icon-action-behaviour" src={iterationIcon} alt="Iteration Action" />
        </Tooltip>
      </>
    );
  }
  if (actionType.includes("PAGINATION")) {
    return (
      <>
        <Tooltip position="top" content="This action has pagination enabled">
          <img className="icon24 icon-action-behaviour" src={paginationIcon} alt="Pagination Action" />
        </Tooltip>
      </>
    );
  }
  return null; // Return null if no matching actionType is found
};
